import BaseApi from './BaseApi';

/**
 * API for managing workflow information
 * @param {String} baseURL
 */
const create = () => {  // this will change for prod deployment
    // Create and configure an apisauce-based api object.
    const api = BaseApi.create({
        timeout: 60000
    });

    const getProduct = (action) => {
        var payload = {
            "taxYear": action.data.taxYear,
            "productName": action.data.product,
            "viewModelId": action.data.id,
            "clientId": action.data.clientId
        }
        return api.getWithPayload('returns/summary', payload)
    }

    const getReturnsByAccount = (accountId) => api.get(`returns?accountid=${accountId}`);

    const getPresalesByAccount = (accountId) => api.get(`presales?accountid=${accountId}`);

    const getPresale = (id, taxYear) => api.get(`presales/${id}/year/${taxYear}`);

    const getActivationCodes = (id, taxYear, clientId) => api.get(`coupons/${id}/clients/${clientId}/year/${taxYear}/activationcodes`);

    const getExpertReview = (action) => api.get(`returns/${action.taxYear}/${action.viewModelId}/expertreview`);

    const getAuditProtection = (action) => api.get(`returns/${action.taxYear}/${action.viewModelId}/auditprotection`);

    const getOte = (id) => api.get(`ote/cases/${id}`);

    const getOteReturnsByAccount = (accountId) => api.get(`ote/cases?accountid=${accountId}`);

    const getFiledReturn = (action) => api.get(`returns/${action.taxYear}/${action.fileId}/${action.fileSource}/json`);

    // Return back a collection of functions
    return {
        getProduct,
        getReturnsByAccount,
        getOteReturnsByAccount,
        getExpertReview,
        getAuditProtection,
        getPresalesByAccount,
        getPresale,
        getOte,
        getActivationCodes,
        getFiledReturn
    }
}

// let's return back our create method as the default.
export default {
    create
}
